<template>
  <div id="app">
    <div style="display: none">
      <!-- <audio
        :ref="'Audio' + item.index"
        :src="item.src"
        v-for="(item, index) in prefabArr"
        :key="index"
        preload="auto"
      ></audio> -->
      <audio ref="audioBGM" preload="auto" src="./assets/media/bgm.mp3"></audio>
      <audio
        id="startMusic"
        ref="startMusic"
        preload="auto"
        loop
        src="https://ali-v.cztv.com/cztv/vod/2022/06/03/7405ea89c47e47f48e2ed7ef2b2f8585/h264_128k_mp3.mp3"
      ></audio>
    </div>
    <!-- 加载页 -->
    <transition name="fade">
      <div class="loading-page" v-if="isShowLoading">
        <div class="loading-box">
          <img
            src="./assets/img/icon_loading.png"
            class="icon-loading"
            alt=""
          />
          <p class="progress-txt">{{ progress }}<span>%</span></p>
        </div>
        <img src="./assets/img/rotate_tips.png" class="rotate-tips" alt="" />

        <p class="loading-desc">
          {{ loadingTxt[loadingIndex] }}
        </p>

        <!-- <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <p class="loading-desc">
                方响：由十六枚长方铁片组成，铁槌击奏声音清浊不等。
              </p>
            </div>
            <div class="swiper-slide">
              <p class="loading-desc">
                琵琶：中国传统弹拨乐器，音色清澈短促，颗粒感强。
              </p>
            </div>
            <div class="swiper-slide">
              <p class="loading-desc">
                古琴：音域宽广，音色深沉，余音悠远，属八音中的丝。
              </p>
            </div>
            <div class="swiper-slide">
              <p class="loading-desc">
                箜篌：中国传统弹弦乐器，其音域宽广、音色柔美清澈。
              </p>
            </div>
          </div>
        </div> -->

        <img src="./assets/img/logo.png" class="logo" alt="" />
      </div>
    </transition>
    <!-- 加载页 -->
    <!-- 首页 旋转地球 -->
    <div
      :class="[isShowEarthPage ? '' : 'hide', 'earth-page']"
      ref="earthPage"
      id="earthLayer"
    >
      <div id="globe" :class="['globe', globeAni ? 'animation' : '']"></div>
      <div
        v-show="!globeAni"
        :class="[isShowEarthPage ? 'animate' : '', 'theme']"
      >
        <div class="theme-left"></div>
        <div class="theme-center"></div>
        <div class="theme-right"></div>
        <img src="./assets/img/theme.png" class="theme-img" alt="" />
      </div>
      <img
        v-show="!globeAni"
        src="./assets/img/roll_tips.png"
        class="roll-tips"
        alt=""
      />
      <div v-show="!globeAni" class="roll-box">
        <img class="roll-arrow" src="./assets/img/roll_arrow.png" alt="" />
        <img src="./assets/img/hand.png" class="hand" alt="" />
      </div>
    </div>

    <img
      v-show="showStartBtn"
      src="./assets/img/cover_layer.png"
      class="cover-layer"
      alt=""
    />

    <div @click="showCloudFn" v-show="showStartBtn" class="start-cloud-btn">
      <img src="./assets/img/start_btn.png" alt="" />
    </div>

    <div v-show="globeAni" :class="['start-story-wrap', globeAni ? 'ani' : '']">
      <img src="./assets/img/start_story.png" class="start-story" alt="" />
      <div class="light"></div>
    </div>

    <!-- <img
      @click="showCloudFn"
      v-show="showStartBtn"
      src="./assets/img/start_btn.png"
      class="start-cloud-btn"
      alt=""
    /> -->

    <div class="cloud-box" v-show="showCloud">
      <img
        ref="cloudImg"
        src="./assets/img/cloud.png"
        class="cloud-img"
        alt=""
      />
    </div>
    <!-- <div v-show="globeAni" class="cover-page" style="position:absolute; top: 0;left:0;width:100%;height:100%">
      
    </div> -->
    <!-- 首页 旋转地球 -->
    <!-- 视频动画页面 -->
    <transition name="fade">
      <div class="video-page" ref="videoPage" v-show="isShowVideoPage">
        <div class="video-scenes">
          <div class="video-wrap">
            <video
              x5-video-player-type="h5"
              playsinline
              ref="videoScenes1"
              id="videoScenes"
              class="video"
              src="https://ali-v.cztv.com/cztv/vod/2022/06/01/b3a2918a3f4841278a33b2641d34da5f/h264_800k_mp4.mp4"
            ></video>
          </div>
          <!-- 乐器提示文案 -->
          <img
            v-show="showVideoTipsBtn1"
            @click="showTips1Fn"
            src="./assets/img/know_btn.png"
            class="know-btn gq"
            alt=""
          />
          <img
            src="./assets/img/intro_tips_gq.png"
            :class="['intro-tips', showTips1 ? 'show' : '']"
            alt=""
          />

          <img
            v-show="showVideoTipsBtn2"
            @click="showTips2Fn"
            src="./assets/img/know_btn.png"
            class="know-btn fx"
            alt=""
          />
          <img
            src="./assets/img/intro_tips_fx.png"
            :class="['intro-tips', showTips2 ? 'show' : '']"
            alt=""
          />

          <img
            v-show="showVideoTipsBtn3"
            @click="showTips3Fn"
            src="./assets/img/know_btn.png"
            class="know-btn pp"
            alt=""
          />
          <img
            src="./assets/img/intro_tips_pp.png"
            :class="['intro-tips', showTips3 ? 'show' : '']"
            alt=""
          />

          <img
            v-show="showVideoTipsBtn4"
            @click="showTips4Fn"
            src="./assets/img/know_btn.png"
            class="know-btn sz"
            alt=""
          />
          <img
            src="./assets/img/intro_tips_sz.png"
            :class="['intro-tips', showTips4 ? 'show' : '']"
            alt=""
          />

          <!-- 乐器提示文案 -->

          <div class="touch-tips-box" v-show="isShowTouchTips">
            <img src="./assets/img/touch_tips_hand.png" class="hand" alt="" />
            <p class="tips-txt">长按前进</p>
          </div>

          <div class="click-tips-box" v-show="isShowClickTips">
            <img
              src="./assets/img/tips_icon_fx.png"
              class="tips-icon-fx"
              alt=""
            />
            <img src="./assets/img/fx_hand.png" class="fx-hand" alt="" />
            <p class="tips-txt">点击敲打方响</p>
          </div>

          <div class="move-tips-box" v-show="isShowMoveTips">
            <img
              src="./assets/img/move_arrow_left.png"
              class="arrow-left"
              alt=""
            />
            <img
              src="./assets/img/move_arrow_right.png"
              class="arrow-right"
              alt=""
            />
            <img src="./assets/img/move_hand.png" class="move-hand" alt="" />
            <p class="tips-txt">左右滑动门帘</p>
          </div>

          <div class="sz-click-box" v-show="isShowSzClickTips">
            <img
              src="./assets/img/sz_click_hand.png"
              class="sz-click-hand"
              alt=""
            />
            <p class="tips-txt">点击屏幕敲响水盏</p>
          </div>
        </div>

        <img
          v-show="isShowPass"
          @click="passVideo"
          src="./assets/img/video_pass_btn.png"
          class="video-pass-btn"
          alt=""
        />
      </div>
    </transition>

    <transition name="fade">
      <div class="scenes-end-page" v-show="isShowScenesEndPage">
        <div class="cover-page">
          <img
            @click="toCreateMusicPage"
            src="./assets/img/start_play_btn.png"
            class="start-btn"
            alt=""
          />
        </div>
      </div>
    </transition>
    <!-- 视频动画页面 -->
    <!-- 创作音乐页 -->
    <transition name="fade">
      <div class="create-music-page" v-show="isShowCreateMusicBox">
        <!-- 创作界面上半区域 -->
        <div class="client-box">
          <div class="client-left">
            <!-- 返回 -->
            <img
              @click="backVideoScenes"
              src="./assets/img/back_btn.png"
              class="back-btn"
              alt=""
            />
            <!-- 返回 -->
            <!-- 呼吸灯 -->
            <div class="light-box">
              <img
                src="./assets/img/light_close.png"
                class="light-close"
                alt=""
              />
              <img src="./assets/img/light.png" class="light-open" alt="" />
            </div>
            <!-- 呼吸灯 -->
            <div class="wheel-box">
              <img src="./assets/img/wheel.png" class="wheel" alt="" />
            </div>
            <img src="./assets/img/seal.png" class="seal" alt="" />
            <img src="./assets/img/slogen.png" class="slogen" alt="" />

            <!-- 乐器提示 -->
            <div class="hint-box" v-show="isShowHint">
              <img src="./assets/img/icon_ding.png" class="icon-ding" alt="" />
              <img
                @click="isShowHint = false"
                src="./assets/img/close_tips_btn.png"
                class="close-btn"
                alt=""
              />
              <p>{{ hintTxt }}</p>
            </div>
            <!-- 乐器提示 -->
          </div>
          <!-- 视频区域 -->
          <div class="video-box">
            <video
              muted
              preload="auto"
              x5-video-player-type="h5"
              playsinline="playsinline"
              webkit-playsinline
              x-webkit-airplay="true"
              src="https://ali-v.cztv.com/cztv/vod/2022/06/01/dabc3f6cb09f44ddb16af63c7be650c7/h264_450k_mp4.mp4"
              poster="./assets/img/video_poster.jpg"
              class="video"
              ref="musicVideo"
            ></video>
            <!-- 视频区域 -->
          </div>

          <div class="client-right">
            <img src="./assets/img/dot.png" class="dot1" alt="" />
            <img src="./assets/img/dot.png" class="dot2" alt="" />
            <div class="vol-control-box">
              <img src="./assets/img/dot_min.png" class="dot-min" alt="" />
            </div>
            <div class="music-control-container">
              <div class="music-control-box">
                <p class="control-txt">OFF</p>
                <div class="control-wrap">
                  <img
                    src="./assets/img/music_control_icon.png"
                    class="music-control-icon"
                    alt=""
                  />
                </div>
                <p class="control-txt">ON</p>
              </div>
              <img
                src="./assets/img/music_track_bg.jpg"
                class="music-track"
                alt=""
              />
              <img
                v-show="canCompleteMusic"
                src="./assets/img/music.gif"
                class="music-gif"
                alt=""
              />
            </div>
          </div>

          <img src="./assets/img/line.png" class="line" alt="" />
        </div>
        <!-- 创作界面上半区域 -->
        <!-- 创作界面下半区域 -->
        <div class="musical-instrument-box">
          <!-- 预制乐器 -->
          <div class="control-left-box">
            <img src="./assets/img/prefab_title.png" class="title" alt="" />
            <div class="musical-instrument-wrap">
              <div
                :class="[
                  item.disable ? 'disable' : '',
                  'musical-instrument-item'
                ]"
                v-for="(item, index) in prefabArr"
                :key="index"
                @click="playPrefabMusic(item, index)"
              >
                <div :class="['item-img', item.isplay ? 'active' : '']">
                  <img v-show="!item.isplay" :src="item.icon" alt="" />
                  <img v-show="item.isplay" :src="item.iconAct" alt="" />
                </div>
                <!-- <img src="./assets/img/icon_gq.png" class="item-img" alt="" />
              <img
                src="./assets/img/icon_bz_act.png"
                class="item-img"
                alt=""
              /> -->
                <p class="name">{{ item.name }}</p>
              </div>
            </div>
          </div>
          <!-- 预制乐器 -->
          <img src="./assets/img/line2.png" class="line" alt="" />
          <!-- 自定义乐器 -->
          <div class="control-center-box">
            <img src="./assets/img/customize_title.png" class="title" alt="" />
            <div class="musical-instrument-wrap">
              <div
                v-for="(item, index) in customizeArr.slice(0, 10)"
                :key="index"
                :class="[
                  item.disable ? 'disable' : '',
                  'musical-instrument-icon'
                ]"
              >
                <div @click="playMusic(item)">
                  <img :src="item.icon" alt="" class="icon-img" />
                  <img
                    v-show="item.isplay"
                    :src="item.iconAct"
                    class="icon-img-act"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 自定义乐器 -->
          <img src="./assets/img/line2.png" class="line" alt="" />

          <div class="control-right-box">
            <img
              @click="resetMusic"
              src="./assets/img/reset_btn.png"
              class="reset-btn"
              alt=""
            />
            <img
              v-show="!canCompleteMusic"
              src="./assets/img/confirm_btn_dis.png"
              class="confirm-btn-dis"
              alt=""
            />
            <img
              @click="completeCreate"
              v-show="canCompleteMusic"
              src="./assets/img/confirm_btn.png"
              class="confirm-btn"
              alt=""
            />
          </div>
        </div>
        <!-- 创作界面下半区域 -->
        <!-- 引导页 -->
        <transition name="fade">
          <div class="guide-page" v-if="isShowGuidePage">
            <transition name="fade">
              <img
                v-if="isShowGuideBtn"
                @click="guideStep1"
                src="./assets/img/guide_btn.png"
                class="guide-btn"
                alt=""
              />
            </transition>
            <transition-group name="fade">
              <div key="box1" class="guide-box1" v-show="isShowGuideBox1">
                <img
                  @click="guideStep2"
                  v-show="isShowGuide1"
                  src="./assets/img/guide_music_btn1.png"
                  class="music-btn1"
                  alt=""
                />
                <img
                  @click="guideStep3"
                  v-show="isShowGuide2"
                  src="./assets/img/guide_music_btn2.png"
                  class="music-btn2"
                  alt=""
                />
                <img
                  src="./assets/img/guide_hand.png"
                  class="guide-hand"
                  alt=""
                />
                <img
                  v-show="isShowGuide1"
                  src="./assets/img/guide_text1.png"
                  class="guide-text1"
                  alt=""
                />
                <img
                  v-show="isShowGuide2"
                  src="./assets/img/guide_text2.png"
                  class="guide-text2"
                  alt=""
                />
              </div>
              <div key="box2" class="guide-box2" v-show="isShowGuideBox2">
                <img
                  @click="guideStep4"
                  v-show="!playGuideMusic"
                  src="./assets/img/guide_music_btn3.png"
                  class="guide-music-btn3"
                  alt=""
                />
                <img
                  src="./assets/img/guide_music_btn4.png"
                  class="guide-music-btn4"
                  v-show="playGuideMusic"
                  alt=""
                />
                <img
                  v-show="isShowGuide3"
                  src="./assets/img/guide_text3.png"
                  class="guide-text3"
                  alt=""
                />
                <img
                  src="./assets/img/guide_hand.png"
                  class="guide-hand"
                  alt=""
                />
                <!-- <img
              @click="guideStep5"
              v-show="isShowGuide4"
              src="./assets/img/guide_music_btn4.png"
              class="guide-music-btn3"
              alt=""
            /> -->
                <img
                  v-show="isShowGuide4"
                  src="./assets/img/guide_text4.png"
                  class="guide-text4"
                  alt=""
                />
              </div>
            </transition-group>
            <transition name="fade">
              <div class="guide-tips-wrap">
                <img
                  @click="guideStepEnd"
                  v-show="isShowGuideEdnBtn"
                  src="./assets/img/guide_tips_btn.png"
                  class="guide-tips-btn"
                  alt=""
                />
                <img
                  src="./assets/img/guide_tips_hand.png"
                  class="guide-tips-hand"
                  alt=""
                />
              </div>
            </transition>
          </div>
        </transition>
        <!-- 引导页 -->
      </div>
    </transition>
    <!-- 创作音乐页 -->
    <!-- 生成结果页 -->
    <transition name="fade">
      <div class="complete-page" v-show="isShowCompletePage">
        <div class="inner-page">
          <div class="left-box">
            <div :class="[isPlayMusic ? 'play' : '', 'phonograph-box']">
              <img
                src="./assets/img/phonograph_end.png"
                class="phonograph"
                alt=""
              />
              <img
                @click="playCreatedMusic"
                src="./assets/img/music_play_icon.png"
                class="play-icon"
                alt=""
                v-show="!isPlayMusic"
              />
              <div class="pointer-box">
                <img src="./assets/img/pointer.png" class="pointer" alt="" />
              </div>
            </div>
            <img
              v-if="!isShare"
              src="./assets/img/ai_tips.png"
              class="ai-tips"
              alt=""
            />
          </div>
          <div class="right-box">
            <img
              v-if="isShare"
              src="./assets/img/result_tips_other.png"
              class="result-tips"
              alt=""
            />
            <img
              v-else
              src="./assets/img/result_tips.png"
              class="result-tips"
              alt=""
            />
            <img :src="resultMusicArr[0].resultIndet" class="identity" alt="" />
            <img src="./assets/img/result_header.png" class="header" alt="" />
            <!-- 弹奏结果 -->
            <div class="result-box">
              <!-- 高频演奏 -->
              <div class="result-count-box">
                <div
                  class="result-count"
                  v-for="(item, index) in resultMusicArr"
                  :key="index"
                >
                  <img :src="item.countImg" alt="" />
                  <p class="count">
                    {{
                      item.clickCount &lt; 10
                        ? "0" + item.clickCount
                        : item.clickCount
                    }}
                  </p>
                </div>
              </div>
              <!-- 高频演奏 -->

              <!-- 代表诗词 -->
              <img
                :src="resultMusicArr[0].resultTxt"
                class="result-txt"
                alt=""
              />
              <!-- 代表诗词 -->
            </div>
            <!-- 弹奏结果 -->
            <img
              v-if="isShare"
              @click="restart"
              src="./assets/img/restart_btn.png"
              class="restart-btn"
              alt=""
            />

            <div v-else class="btn-box">
              <img
                @click="hideCompletePage"
                src="./assets/img/replay_btn.png"
                class="replay-btn"
                alt=""
              />
              <img
                @click="makePoster"
                src="./assets/img/share_btn.png"
                class="share-btn"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 生成结果页 -->
    <!-- 保存海报页 -->
    <transition name="fade">
      <div class="poster-page" v-show="isShowSavePage">
        <img
          @click="isShowSavePage = false"
          src="./assets/img/close_btn.png"
          class="close-btn"
          alt=""
        />
        <div class="inner-page">
          <img :src="resultPoster" class="poster" alt="" />
          <div class="desc-box">
            <img src="./assets/img/desc_title.png" class="desc-title" alt="" />
            <img :src="resultMusicArr[0].posterTxt" class="poster-txt" alt="" />
            <img src="./assets/img/save_tips.png" class="save-tips" alt="" />
          </div>
          <div class="cover-poster-wrap">
            <img
              :class="['cover-poster', hidePoster ? 'hide' : '']"
              :src="resultPoster"
              alt=""
            />
          </div>
        </div>
      </div>
    </transition>
    <!-- 保存海报页 -->
  </div>
</template>
<script>
import "../node_modules/swiper/css/swiper.min.css";
import { wxShare } from "./utils/wxUtils.js";
import axios from "axios";
import { getQueryString } from "./utils";
import QRCode from "qrcode";
import { Howl } from "howler";
import { Globe } from "./assets/js/globe.js";
import { moon } from "./assets/js/moon.js";
import { imagesArr } from "./assets/js/img.js";
import baseImg from "./assets/img/poster.png";
import pointer from "./assets/img/point_min.png";
import phonograph from "./assets/img/phonograph_end.png";
import titleMy from "./assets/img/titleMy.png";
import descMy from "./assets/img/descMy.png";
import qrcodeTips from "./assets/img/qrcode_tips.png";
import { setInterval, setTimeout } from "timers";
export default {
  name: "app",
  data() {
    return {
      startMusic: null,
      isPlaying: false,
      showVideoTipsBtn1: false,
      showTips1: false,
      showVideoTipsBtn2: false,
      showTips2: false,
      showVideoTipsBtn3: false,
      showTips3: false,
      showVideoTipsBtn4: false,
      showTips4: false,
      hidePoster: true,
      loadingIndex: 0,
      loadingTxt: [
        "方响：由十六枚长方铁片组成，铁槌击奏声音清浊不等。",
        "琵琶：中国传统弹拨乐器，音色清澈短促，颗粒感强。",
        "琴：音域宽广，音色深沉，余音悠远，属八音中的丝。",
        "箜篌：中国传统弹弦乐器，其音域宽广、音色柔美清澈。"
      ],
      videoScenes1: null,
      videoLoadedCount: 0, // 视频动画场景加载次数
      showStartBtn: false,
      globeAni: false,
      isShowPass: true, // 是否显示跳过
      isShare: false, // 是否是分享
      uuid: "", // 用户唯一id
      isShowHint: false, // 是否显示乐器提示
      progress: 0, // 加载进度
      isShowLoading: true, // 是否显示加载页
      isShowEarthPage: false, // 是否显示首页
      isShowVideoPage: false, // 是否显示视频页
      showCloud: false, // 显示云层
      isShowScenesEndPage: false, // 显示视频结果页
      isShowCreateMusicBox: false, // 是否显示创作音乐界面
      isShowCompletePage: false, // 是否显示结果页
      isShowSavePage: false,
      globe: null, // 存放地球实例
      videoControlObj: {
        scenes1: {
          show: true
        },
        scenes2: {
          show: false
        }
      }, // 控制视频场景播放
      fxClickNum: 0, // 方响点击次数
      szClickNum: 0, // 水盏点击次数
      touchMove: false, // 是否滑动页面
      isShowTouchTips: true, // 长按提示
      isShowClickTips: false, // 敲打方响提示
      isShowMoveTips: false, // 滑动提示
      isShowSzClickTips: false,
      isShowGuidePage: true, // 是否显示引导页
      isShowGuideBtn: false, // 是否显示引导按钮
      isShowGuideBox1: false,
      isShowGuide1: false, // 引导第一步
      isShowGuide2: false, // 引导第二步
      isShowGuideBox2: false,
      isShowGuide3: false, // 引导第三步
      isShowGuide4: false, // 引导第四步
      playGuideMusic: false,
      playCount: 0,
      isShowGuideEdnBtn: true,
      hintTxt: "",
      isReset: false,
      instrumentArr: [],
      prefabObj: {},
      customizeObj: {},
      // 预制乐器
      prefabArr: [
        {
          index: 10,
          name: "方 响",
          hintTxt: "方响：由十六枚长方铁片组成，铁槌击奏声音清浊不等。",
          icon: require("./assets/img/icon_l_fx.png"),
          iconAct: require("./assets/img/icon_l_fx_act.png"),
          src: require("./assets/media/long_fx.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/e098e3035170494fb384297b4d9c8cd9/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 1
        },
        {
          index: 11,
          name: "歌 板",
          hintTxt: "歌板：歌唱时敲击作为节奏的拍板，双手合击板块出声。",
          icon: require("./assets/img/icon_l_gb.png"),
          iconAct: require("./assets/img/icon_l_gb_act.png"),
          src: require("./assets/media/long_gb.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/de14aa9019014ed7880bb95a158e10cf/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 2
        },
        {
          index: 12,
          name: "古 琴",
          hintTxt: "古琴：音域宽广，音色深沉，余音悠远，属八音中的丝。",
          icon: require("./assets/img/icon_l_gq.png"),
          iconAct: require("./assets/img/icon_l_gq_act.png"),
          src: require("./assets/media/long_gq.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/e1519d9c0f2247f2b3363994be825398/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 3
        },
        {
          index: 13,
          name: "横 笛",
          hintTxt: "横笛：张骞通西域后传入，亦称横吹，其音色清亮悠扬。",
          icon: require("./assets/img/icon_l_hd.png"),
          iconAct: require("./assets/img/icon_l_hd_act.png"),
          src: require("./assets/media/long_hd.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/9914804879cc40f88c7c2e7214a114d5/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 5
        },
        {
          index: 14,
          name: "建 鼓",
          hintTxt: "建鼓：鼓身长而圆，鼓体较大，音量洪大，传播甚远。",
          icon: require("./assets/img/icon_l_jg.png"),
          iconAct: require("./assets/img/icon_l_jg_act.png"),
          src: require("./assets/media/long_jg.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/64657b65912a430ab902e57ef5532d41/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 4
        },
        {
          index: 15,
          name: "箜 篌",
          hintTxt: "箜篌：中国传统弹弦乐器，其音域宽广、音色柔美清澈。",
          icon: require("./assets/img/icon_l_kh.png"),
          iconAct: require("./assets/img/icon_l_kh_act.png"),
          src: require("./assets/media/long_kh.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/20647d8411d84263a9e04c0f95296f64/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 7
        },
        {
          index: 16,
          name: "琵 琶",
          hintTxt: "琵琶：中国传统弹拨乐器，音色清澈短促，颗粒感强。",
          icon: require("./assets/img/icon_l_pp.png"),
          iconAct: require("./assets/img/icon_l_pp_act.png"),
          src: require("./assets/media/long_pp.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/5114fd30d4dc46c98adc2a2c7671e594/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 9
        },
        {
          index: 17,
          name: "细腰鼓",
          hintTxt: "细腰鼓：演奏时挂腰间，正鼓高亢洪亮，和鼓婉转低回。",
          icon: require("./assets/img/icon_l_xg.png"),
          iconAct: require("./assets/img/icon_l_xg_act.png"),
          src: require("./assets/media/long_xg.mp3"),
          // src:
          //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/deef3b76c06142f393e81f321474d9ce/h264_128k_mp3.mp3",
          isplay: false,
          customizeIndex: 10
        }
      ],
      // 自定义乐器
      customizeArr: [
        {
          index: 0,
          clickCount: 0,
          hintTxt: "尺八：中国传统乐器，唐宋时传入日本，音色苍凉辽阔。",
          countImg: require("./assets/img/count_cb.png"),
          resultTxt: require("./assets/img/result_txt_cb.png"),
          phonograph: require("./assets/img/phonograph_cb.png"),
          posterId: require("./assets/img/poster_id_cb.png"),
          posterTxt: require("./assets/img/poster_txt_cb.png"),
          shareTxt: require("./assets/img/share_txt_cb.png"),
          posterCount: require("./assets/img/poster_count_cb.png"),
          src: require("./assets/media/cb.mp3"),
          icon: require("./assets/img/icon_cb.png"),
          iconAct: require("./assets/img/icon_cb_act.png"),
          resultIndet: require("./assets/img/identity_cb.png"),
          timelineTxt:
            "我在宋朝的乐师身份是尺八演奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 1,
          clickCount: 0,
          hintTxt: "方响：由十六枚长方铁片组成，铁槌击奏声音清浊不等。",
          countImg: require("./assets/img/count_fx.png"),
          resultTxt: require("./assets/img/result_txt_fx.png"),
          phonograph: require("./assets/img/phonograph_fx.png"),
          posterId: require("./assets/img/poster_id_fx.png"),
          posterTxt: require("./assets/img/poster_txt_fx.png"),
          shareTxt: require("./assets/img/share_txt_fx.png"),
          posterCount: require("./assets/img/poster_count_fx.png"),
          src: require("./assets/media/fx.mp3"),
          icon: require("./assets/img/icon_fx.png"),
          iconAct: require("./assets/img/icon_fx_act.png"),
          resultIndet: require("./assets/img/identity_fx.png"),
          timelineTxt:
            "我在宋朝的乐师身份是方响独奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 2,
          clickCount: 0,
          hintTxt: "歌板：歌唱时敲击作为节奏的拍板，双手合击板块出声。",
          countImg: require("./assets/img/count_gb.png"),
          resultTxt: require("./assets/img/result_txt_gb.png"),
          phonograph: require("./assets/img/phonograph_gb.png"),
          posterId: require("./assets/img/poster_id_gb.png"),
          posterTxt: require("./assets/img/poster_txt_gb.png"),
          shareTxt: require("./assets/img/share_txt_gb.png"),
          posterCount: require("./assets/img/poster_count_gb.png"),
          src: require("./assets/media/gb.mp3"),
          icon: require("./assets/img/icon_gb.png"),
          iconAct: require("./assets/img/icon_gb_act.png"),
          resultIndet: require("./assets/img/identity_gb.png"),
          timelineTxt:
            "我在宋朝的乐师身份是歌板拍打师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 3,
          clickCount: 0,
          hintTxt: "古琴：音域宽广，音色深沉，余音悠远，属八音中的丝。",
          countImg: require("./assets/img/count_gq.png"),
          resultTxt: require("./assets/img/result_txt_gq.png"),
          phonograph: require("./assets/img/phonograph_gq.png"),
          posterId: require("./assets/img/poster_id_gq.png"),
          posterTxt: require("./assets/img/poster_txt_gq.png"),
          shareTxt: require("./assets/img/share_txt_gq.png"),
          posterCount: require("./assets/img/poster_count_gq.png"),
          src: require("./assets/media/gq.mp3"),
          icon: require("./assets/img/icon_gq1.png"),
          iconAct: require("./assets/img/icon_gq_act1.png"),
          resultIndet: require("./assets/img/identity_gq.png"),
          timelineTxt:
            "我在宋朝的乐师身份是古琴研究师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 4,
          clickCount: 0,
          hintTxt: "建鼓：鼓身长而圆，鼓体较大，音量洪大，传播甚远。",
          countImg: require("./assets/img/count_jg.png"),
          resultTxt: require("./assets/img/result_txt_jg.png"),
          phonograph: require("./assets/img/phonograph_jg.png"),
          posterId: require("./assets/img/poster_id_jg.png"),
          posterTxt: require("./assets/img/poster_txt_jg.png"),
          shareTxt: require("./assets/img/share_txt_jg.png"),
          posterCount: require("./assets/img/poster_count_jg.png"),
          src: require("./assets/media/gu.mp3"),
          icon: require("./assets/img/icon_jg.png"),
          iconAct: require("./assets/img/icon_jg_act.png"),
          resultIndet: require("./assets/img/identity_jg.png"),
          timelineTxt:
            "我在宋朝的乐师身份是建鼓击奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 5,
          clickCount: 0,
          hintTxt: "横笛：张骞通西域后传入，亦称横吹，其音色清亮悠扬。",
          countImg: require("./assets/img/count_hd.png"),
          resultTxt: require("./assets/img/result_txt_hd.png"),
          phonograph: require("./assets/img/phonograph_hd.png"),
          posterId: require("./assets/img/poster_id_hd.png"),
          posterTxt: require("./assets/img/poster_txt_hd.png"),
          shareTxt: require("./assets/img/share_txt_hd.png"),
          posterCount: require("./assets/img/poster_count_hd.png"),
          src: require("./assets/media/hd.mp3"),
          icon: require("./assets/img/icon_hd.png"),
          iconAct: require("./assets/img/icon_hd_act.png"),
          resultIndet: require("./assets/img/identity_hd.png"),
          timelineTxt:
            "我在宋朝的乐师身份是横笛吹奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 6,
          clickCount: 0,
          hintTxt: "笙：簧管乐器，其音色清晰透亮，音域宽广，感染力强。",
          countImg: require("./assets/img/count_s.png"),
          resultTxt: require("./assets/img/result_txt_s.png"),
          phonograph: require("./assets/img/phonograph_s.png"),
          posterId: require("./assets/img/poster_id_hs.png"),
          posterTxt: require("./assets/img/poster_txt_hs.png"),
          shareTxt: require("./assets/img/share_txt_hs.png"),
          posterCount: require("./assets/img/poster_count_hs.png"),
          src: require("./assets/media/s.mp3"),
          icon: require("./assets/img/icon_s.png"),
          iconAct: require("./assets/img/icon_s_act.png"),
          resultIndet: require("./assets/img/identity_hs.png"),
          timelineTxt:
            "我在宋朝的乐师身份是簧笙吹奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 7,
          clickCount: 0,
          hintTxt: "箜篌：中国传统弹弦乐器，其音域宽广、音色柔美清澈。",
          countImg: require("./assets/img/count_kh.png"),
          resultTxt: require("./assets/img/result_txt_kh.png"),
          phonograph: require("./assets/img/phonograph_kh.png"),
          posterId: require("./assets/img/poster_id_kh.png"),
          posterTxt: require("./assets/img/poster_txt_kh.png"),
          shareTxt: require("./assets/img/share_txt_kh.png"),
          posterCount: require("./assets/img/poster_count_kh.png"),
          src: require("./assets/media/sh.mp3"),
          icon: require("./assets/img/icon_kh.png"),
          iconAct: require("./assets/img/icon_kh_act.png"),
          resultIndet: require("./assets/img/identity_kh.png"),
          timelineTxt:
            "我在宋朝的乐师身份是箜篌弹拨师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 8,
          clickCount: 0,
          hintTxt: "云锣：古名云辙、云璈，锣类乐器中能奏出曲调的乐器。",
          countImg: require("./assets/img/count_yl.png"),
          resultTxt: require("./assets/img/result_txt_yl.png"),
          phonograph: require("./assets/img/phonograph_yl.png"),
          posterId: require("./assets/img/poster_id_yl.png"),
          posterTxt: require("./assets/img/poster_txt_yl.png"),
          shareTxt: require("./assets/img/share_txt_yl.png"),
          posterCount: require("./assets/img/poster_count_yl.png"),
          src: require("./assets/media/yl.mp3"),
          icon: require("./assets/img/icon_yl.png"),
          iconAct: require("./assets/img/icon_yl_act.png"),
          resultIndet: require("./assets/img/identity_yl.png"),
          timelineTxt:
            "我在宋朝的乐师身份是云锣敲击师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 9,
          clickCount: 0,
          hintTxt: "琵琶：中国传统弹拨乐器，音色清澈短促，颗粒感强。",
          countImg: require("./assets/img/count_pp.png"),
          resultTxt: require("./assets/img/result_txt_pp.png"),
          phonograph: require("./assets/img/phonograph_pp.png"),
          posterId: require("./assets/img/poster_id_pp.png"),
          posterTxt: require("./assets/img/poster_txt_pp.png"),
          shareTxt: require("./assets/img/share_txt_pp.png"),
          posterCount: require("./assets/img/poster_count_pp.png"),
          src: require("./assets/media/pp.mp3"),
          icon: require("./assets/img/icon_pp.png"),
          iconAct: require("./assets/img/icon_pp_act.png"),
          resultIndet: require("./assets/img/identity_pp.png"),
          timelineTxt:
            "我在宋朝的乐师身份是琵琶弹奏师，正在与谷小雨一起上演舞台首秀"
        },
        {
          index: 10,
          clickCount: 0,
          countImg: require("./assets/img/count_yg.png"),
          resultTxt: require("./assets/img/result_txt_yg.png"),
          phonograph: require("./assets/img/phonograph_yg.png"),
          resultIndet: require("./assets/img/identity_yg.png"),
          posterId: require("./assets/img/poster_id_yg.png"),
          posterTxt: require("./assets/img/poster_txt_yg.png"),
          shareTxt: require("./assets/img/share_txt_yg.png"),
          posterCount: require("./assets/img/poster_count_yg.png"),
          timelineTxt:
            "我在宋朝的乐师身份是腰鼓击打师，正在与谷小雨一起上演舞台首秀"
        }
      ],
      guideMusic: null, // 引导页音乐对象
      guideMusic2: null,
      mySound: null, // 自定义音乐对象实例
      myPrefabSound: null, // 预制音乐对象实例
      BGM_: null, // 背景音乐实例
      customMusicArr: [], // 存放所有弹奏过的自定义音乐
      prefabMusicArr: [], // 存放所有弹奏过的预制音乐
      canCompleteMusic: false, // 是否可以点击完成
      isMusicComplete: false, // 音乐是否制作完成
      isPlayMusic: false, // 是否播放最终生成音乐
      resultMusicArr: [
        {
          clickCount: 0,
          countImg: require("./assets/img/count_pp.png"),
          resultIndet: require("./assets/img/identity_pp.png"),
          phonograph: require("./assets/img/phonograph_pp.png"),
          posterTxt: require("./assets/img/poster_id_pp.png"),
          timelineTxt: "我在宋朝的乐师身份是琵琶弹奏师，正在与谷小雨出道首秀"
        }
      ], // 最终生成的音乐数据
      resultPoster: "", // 最终生成的海报
      shareApp: null // 蓝TV app skd 实例
    };
  },
  created() {
    let shareLink = window.location.href.split("?")[0];
    let ua_str = window.navigator.userAgent.toLowerCase();
    if (/chinabluetv/.test(ua_str)) {
      const shareData = {
        showShareBtn: true,
        url: shareLink, //分享的网址链接
        title: "我从宋朝给你发来一封心动offer", //分享的标题
        content: "“谷小雨”首秀舞台，只等你了！", // 分享的文字
        img: "https://ohudong.cztv.com/1/264397/images/share.jpg" // 分享的图片Url
      };
      this.shareApp = new ShareApp("true", shareData);
      this.shareApp.changeShareInfo(shareData);
    } else {
      wxShare(
        true,
        "我从宋朝给你发来一封心动offer",
        "“谷小雨”首秀舞台，只等你了！",
        "我从宋朝给你发来一封心动offer",
        shareLink,
        "https://ohudong.cztv.com/1/264397/images/share.jpg"
      );
    }
    // 4a3b3e5a7e9748d4a52f9a35e41081ac
    this.uuid = getQueryString("uuid");
    if (this.uuid) {
      this.isShare = true;
      axios({
        url: `https://ichudong.cztv.com/data/composer/get?uuid=${this.uuid}`,
        method: "GET"
      }).then(res => {
        console.log(JSON.parse(res.data.msg));
        let data = JSON.parse(res.data.msg);
        this.prefabMusicArr = data.prefabMusicArr;
        this.customMusicArr = data.customMusicArr;
        this.resultMusicArr = data.resultMusicArr;
        this.isShowCompletePage = true;
      });
    }

    // 实例化音乐对象
    this.mySound = createjs.Sound; // 自定义乐器
    this.myPrefabSound = createjs.Sound; // 预制乐器
    // 添加自定义乐器音乐
    for (let i = 0; i < this.customizeArr.length - 1; i++) {
      this.mySound.registerSound({
        src: this.customizeArr[i].src,
        id: "Audio" + this.customizeArr[i].index
      });
    }

    // for (let j = 0; j < this.customizeArr.length; j++) {
    //   this.customizeObj["audio" + this.customizeArr[j].index] = new Howl({
    //     src: this.customizeArr[j].src,
    //     preload: true,
    //     autoplay: false,
    //     loop: false
    //   });
    // }

    // 添加预制乐器音乐
    for (let n = 0; n < this.prefabArr.length; n++) {
      this.myPrefabSound.registerSound({
        src: this.prefabArr[n].src,
        id: "Audio" + this.prefabArr[n].index
      });
    }

    for (let k = 0; k < this.prefabArr.length; k++) {
      this.prefabObj["audio" + this.prefabArr[k].index] = new Howl({
        src: this.prefabArr[k].src,
        preload: true,
        autoplay: false,
        loop: false
      });
    }
    // document.body.addEventListener("touchstart", function() {
    //   console.log(audio)
    //   // audio.volume(0);
    //   audio.play();
    // });
    // this.prefabObj.audio1 = loadSound(
    //   "http://ali-v.cztv.com/cztv/vod/2022/05/24/64657b65912a430ab902e57ef5532d41/h264_128k_mp3.mp3"
    // );

    // 添加引导页音乐
    this.guideMusic = new Audio();
    this.guideMusic.src = require("./assets/media/long_kh.mp3");
    this.guideMusic2 = new Audio();
    this.guideMusic2.src = require("./assets/media/fx.mp3");

    let txtInterval = setInterval(() => {
      this.loadingIndex = Math.floor(Math.random() * 4);
    }, 1500);

    // 静态资源加载
    let images = imagesArr;
    let l = images.length;
    let loadNum = 0;
    for (let i = 0; i < l; i++) {
      let image = new Image();
      image.onload = () => {
        loadNum++;
        this.progress = parseInt((loadNum / l) * 100) - 1 + "";
        if (loadNum === l) {
          clearInterval(txtInterval);
          setTimeout(() => {
            this.isShowLoading = false;
            this.isShowEarthPage = true;
          }, 5000);
        }
      };
      image.src = images[i];
    }
  },
  mounted() {
    // 旋转屏幕
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    const contentDOM = document.getElementById("app");
    console.log(width, height);
    // var screen_width = width; //屏幕宽度
    if (width < height) {
      // screen_width = height; //如果 是竖屏，灵感的宽度就等于屏高
      contentDOM.style.width = height + "px";
      contentDOM.style.height = width + "px";
      contentDOM.style.marginTop = (height - width) / 2 + "px";
      contentDOM.style.marginLeft = 0 - (height - width) / 2 + "px";
      contentDOM.style.transform = "rotate(90deg)";
    }
    //根据手机旋转的角度来判断
    const evt =
      "onorientationchange" in window ? "orientationchange" : "resize"; //旋转事件
    window.addEventListener(
      evt,
      function() {
        console.log(width, height);
        if (window.orientation === 90 || window.orientation === -90) {
          //旋转到 90 或 -90 度，即竖屏到横屏
          // screen_width = height; //横屏，灵感的宽度就等于屏高
          contentDOM.style.width = height + "px";
          contentDOM.style.height = width + "px";
          contentDOM.style.marginTop = "0px";
          contentDOM.style.marginLeft = "0px";
          contentDOM.style.transform = "none"; //不旋转；
        } else {
          //旋转到 180 或 0 度，即横屏到竖屏
          // screen_width = height; //竖屏，灵感的宽度就等于屏高
          contentDOM.style.width = height + "px";
          contentDOM.style.height = width + "px";
          contentDOM.style.marginTop = (height - width) / 2 + "px";
          contentDOM.style.marginLeft = 0 - (height - width) / 2 + "px";
          contentDOM.style.transform = "rotate(90deg)"; //旋转90度
        }
        //事件监听
      },
      false
    );

    // this.swiper = new Swiper(".swiper-container", {
    //   direction: "vertical",
    //   autoplay: true
    // });

    // 实例化地球模型
    let div = document.getElementById("globe");
    let ctrls = document.getElementById("earthLayer");
    let urls = {
      // earth: require("./assets/img/moon.jpg"),
      // bump: require("./assets/img/earth-bump.jpg")
      earth: moon
    };
    this.globe = new Globe(div, urls, ctrls);
    this.globe.init();

    let startY, moveEndY;
    // this.$refs.earthPage.addEventListener("touchstart", e => {
    //   e.preventDefault();
    //   startY = e.changedTouches[0].screenY;

    //   // this.$refs.videoScenes2.play();
    //   // this.$refs.videoScenes2.pause();
    // });

    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    if (!isAndroid && !this.uuid) {
      // this.startMusic = new Howl({
      //   src:
      //     "https://ali-v.cztv.com/cztv/vod/2022/06/03/7405ea89c47e47f48e2ed7ef2b2f8585/h264_128k_mp3.mp3",
      //   preload: true,
      //   autoplay: true,
      //   loop: true,
      //   onplay: () => {
      //     this.isPlaying = true;
      //   },
      //   onpause: () => {
      //     this.isPlaying = false;
      //   },
      //   onload: () => {
      //   }
      // });
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.invoke("getNetworkType", {}, function(e) {
            document.getElementById("startMusic").play();
            document.getElementById("startMusic").pause();
          });
        },
        false
      );
    }

    this.$refs.earthPage.addEventListener("touchmove", e => {
      e.preventDefault();
      // moveEndY = e.changedTouches[0].screenY;
      // this.showCloud = true;
      this.globeAni = true;
      this.showStartBtn = true;
      this.$refs.startMusic.play();
      // if (moveEndY - startY > 100) {
      //   this.showCloud = true;
      //   // this.$refs.earthPage.removeEventListener("touchmove");
      // }
    });
    this.$refs.cloudImg.addEventListener(
      "animationend",
      () => {
        this.isShowEarthPage = false;
        this.isShowVideoPage = true;
        this.showCloud = false;
        this.globeAni = false;
      },
      false
    );

    // this.$refs.videoScenes1.addEventListener("canplay", () => {
    //   if (this.videoLoadedCount <= 0) {
    //     this.isShowLoading = false;
    //     this.isShowEarthPage = true;
    //     this.videoLoadedCount++;
    //   }
    // });

    this.videoScenes1 = document.getElementById("videoScenes");

    // let u = navigator.userAgent;
    // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    // alert(isAndroid)
    // if (!isAndroid) {
    // 视频场景播放
    this.videoScenes1.addEventListener("touchstart", () => {
      console.log("touchstart");
      if (this.videoScenes1.currentTime < 11) {
        this.videoScenes1.play();
        // alert("aaaa")
        this.isShowPass = false;
        this.isShowTouchTips = false;
      }
    });
    this.videoScenes1.addEventListener("touchend", () => {
      console.log("touchend");
      // 场景一 暂停提示长按继续
      if (this.videoScenes1.currentTime < 11) {
        this.videoScenes1.pause();
        this.isShowPass = true;
        this.isShowTouchTips = true;
      }
      if (
        this.videoScenes1.currentTime > 14 &&
        this.videoScenes1.currentTime < 25
      ) {
        this.isShowClickTips = false;
        this.videoScenes1.play();
      }
      if (
        this.videoScenes1.currentTime > 50 &&
        this.videoScenes1.currentTime < 63
      ) {
        this.isShowClickTips = false;
        this.isShowSzClickTips = false;
        this.videoScenes1.play();
      }
    });
    // this.videoScenes1.addEventListener("click", () => {

    // });
    this.videoScenes1.addEventListener("touchmove", () => {
      if (this.videoScenes1.currentTime > 35) {
        this.touchMove = true;
        this.isShowMoveTips = false;
        this.videoScenes1.play();
      }
    });
    this.videoScenes1.addEventListener("timeupdate", () => {
      let currTime = this.videoScenes1.currentTime.toFixed(2);
      // console.log(currTime);

      if (currTime > 6.8 && currTime < 9) {
        this.showVideoTipsBtn1 = true;
      } else {
        this.showVideoTipsBtn1 = false;
      }

      if (currTime > 17.7 && currTime < 30) {
        this.showVideoTipsBtn2 = true;
      } else {
        this.showVideoTipsBtn2 = false;
      }

      if (currTime > 42 && currTime < 48) {
        this.showVideoTipsBtn3 = true;
      } else {
        this.showVideoTipsBtn3 = false;
      }

      if (currTime > 58 && currTime < 62) {
        this.showVideoTipsBtn4 = true;
      } else {
        this.showVideoTipsBtn4 = false;
      }

      // if (currTime < 15) {
      //   this.isShowPass = false;
      // }
      if (currTime >= 17.3 && this.fxClickNum == 0) {
        this.videoScenes1.pause();
        this.isShowPass = true;
        this.isShowClickTips = true;
        this.fxClickNum++;
      }
      if (currTime >= 37 && this.touchMove == false) {
        this.isShowMoveTips = true;
        this.videoScenes1.pause();
      }
      if (currTime >= 56.5 && this.szClickNum == 0) {
        this.videoScenes1.pause();
        this.isShowSzClickTips = true;
        this.szClickNum++;
      }
    });
    // } else {
    //   this.isShowTouchTips = false;
    // }

    this.videoScenes1.addEventListener("ended", () => {
      this.$refs.videoScenes1.pause();
      this.$refs.videoScenes1.currentTime = 0;
      this.isShowVideoPage = false;
      this.isShowScenesEndPage = true;
    });

    // 添加背景音乐
    // this.BGM_ = new Audio();
    // this.BGM_.src = require("./assets/media/bgm.mp3");
    this.BGM_ = this.$refs.audioBGM;
    // 监听背景音乐播放结束
    this.BGM_.addEventListener("ended", () => {
      this.BGM_.currentTime = 0;
      this.BGM_.pause();
      this.mySound.stop();
      this.$refs.musicVideo.pause();
      for (let i = 0; i < this.customizeArr.length; i++) {
        this.$set(this.customizeArr[i], "isplay", false);
        this.$set(this.customizeArr[i], "disable", true);
      }

      this.completeCreate();
    });
  },
  methods: {
    showTips1Fn() {
      this.showTips1 = true;
      setTimeout(() => {
        this.showTips1 = false;
      }, 3000);
    },
    showTips2Fn() {
      this.showTips2 = true;
      setTimeout(() => {
        this.showTips2 = false;
      }, 3000);
    },
    showTips3Fn() {
      this.showTips3 = true;
      setTimeout(() => {
        this.showTips3 = false;
      }, 3000);
    },
    showTips4Fn() {
      this.showTips4 = true;
      setTimeout(() => {
        this.showTips4 = false;
      }, 3000);
    },
    // 云雾动画
    showCloudFn() {
      this.$refs.startMusic.pause();
      this.showStartBtn = false;
      this.showCloud = true;

      // 视频播放一帧 防止空白
      this.$refs.videoScenes1.play();
      // let u = navigator.userAgent;
      // let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      // if (!isAndroid) {
      setTimeout(() => {
        this.$refs.videoScenes1.pause();
      }, 200);
      // }
    },
    // 点击跳过视频
    passVideo() {
      this.$refs.videoScenes1.pause();
      this.$refs.videoScenes1.currentTime = 0;
      this.isShowTouchTips = false;
      this.isShowClickTips = false;
      this.isShowMoveTips = false;

      this.isShowVideoPage = false;
      this.isShowScenesEndPage = true;
    },
    // 视频场景结束 开始演奏
    toCreateMusicPage() {
      this.$refs.videoScenes1.pause();
      this.$refs.videoScenes1.currentTime = 0;
      this.isShowScenesEndPage = false;
      this.isShowCreateMusicBox = true;
      if (!this.isShowGuidePage) {
        this.guideStepEnd();
      }
    },
    // 开始引导
    guideStep1() {
      this.isShowGuideBtn = false;
      this.isShowGuideBox1 = true;
      this.isShowGuide1 = true;
    },
    // 引导1
    guideStep2() {
      // this.mySound.play("Audio11");
      this.guideMusic.play();
      this.isShowGuide1 = false;
      this.isShowGuide2 = true;
    },
    // 引导2
    guideStep3() {
      this.guideMusic.pause();
      this.isShowGuideBox1 = false;
      this.isShowGuideBox2 = true;
      this.isShowGuide3 = true;
    },
    // 引导3
    guideStep4() {
      this.playCount++;
      let myInstance = this.mySound.play("Audio1");
      myInstance.on("complete", () => {
        this.playGuideMusic = false;
        if (this.playCount >= 2) {
          this.isShowGuideBox2 = false;
          this.isShowGuideEdnBtn = true;
        }
      });
      this.isShowGuide3 = false;
      this.playGuideMusic = true;
      this.isShowGuide4 = true;
    },
    // 引导结束
    guideStepEnd() {
      this.isShowGuidePage = false;
      this.canCompleteMusic = true;
      this.BGM_.play();
      this.$refs.musicVideo.play();
      // 播放预制音乐
      // this.myPrefabSound.volume = 0
      // for (let j = 0; j < this.prefabArr.length; j++) {
      //   this.myPrefabSound.play("Audio" + this.prefabArr[j].index);
      // }
      // for (let i = 10; i < this.prefabArr.length + 10; i++) {
      //   this.$refs["Audio" + i][0].muted = "muted";
      //   this.$refs["Audio" + i][0].play();
      // }

      for (let k = 0; k < this.prefabArr.length; k++) {
        this.prefabObj["audio" + this.prefabArr[k].index].volume(0);
        this.prefabObj["audio" + this.prefabArr[k].index].play();
      }
    },
    // 返回视频页
    backVideoScenes() {
      window.location.replace(window.location.href.split("?")[0]);
      return;
      this.BGM_.pause();
      this.$refs.musicVideo.pause();
      this.BGM_.currentTime = 0;
      this.$refs.musicVideo.currentTime = 0;
      this.mySound.stop();
      this.customMusicArr = [];
      this.prefabMusicArr = [];
      this.resultMusicArr = [
        {
          clickCount: 0,
          countImg: require("./assets/img/count_pp.png"),
          resultIndet: require("./assets/img/identity_pp.png"),
          phonograph: require("./assets/img/phonograph_pp.png"),
          posterTxt: require("./assets/img/poster_id_pp.png")
        }
      ];
      for (let i = 0; i < this.customizeArr.length; i++) {
        this.$set(this.customizeArr[i], "isplay", false);
        this.$set(this.customizeArr[i], "disable", false);
        this.$set(this.customizeArr[i], "clickCount", 0);
      }
      for (let j = 0; j < this.prefabArr.length; j++) {
        this.prefabObj["audio" + this.prefabArr[j].index].stop();
        this.$set(this.prefabArr[j], "isplay", false);
        this.$set(this.prefabArr[j], "clickCount", 0);
      }

      this.isShowPass = true;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
      if (!isAndroid) {
        this.isShowTouchTips = true;
        this.$refs.videoScenes1.play();
        setTimeout(() => {
          this.$refs.videoScenes1.pause();
        }, 200);
        this.fxClickNum = 0;
        this.touchMove = false;
        this.szClickNum = 0;
      } else {
        this.videoScenes1.play();
      }

      this.isShowCreateMusicBox = false;
      this.isShowVideoPage = true;
    },
    // 播放背景音乐
    playBgm() {
      this.BGM_.play();
      this.isPlayMusic = true;
    },
    // 点击弹奏预制乐器
    playPrefabMusic(item, i) {
      this.canCompleteMusic = true;
      this.BGM_.play();
      this.$refs.musicVideo.play();
      this.hintTxt = item.hintTxt;
      this.isShowHint = true;

      if (this.isReset) {
        for (let k = 0; k < this.prefabArr.length; k++) {
          this.prefabObj["audio" + this.prefabArr[k].index].volume(0);
          this.prefabObj["audio" + this.prefabArr[k].index].play();
        }
      }
      this.isReset = false;

      if (this.prefabArr[i].isplay) {
        this.prefabMusicArr.map((val, index) => {
          if (val.index === item.index) {
            this.prefabMusicArr.splice(index, 1);
          }
        });
        // this.$refs["Audio" + item.index][0].pause();
        // this.$refs["Audio" + item.index][0].muted = "muted";
        this.prefabObj["audio" + item.index].volume(0);
        this.$set(this.prefabArr[i], "isplay", false);
        this.customizeArr[item.customizeIndex].clickCount--;
      } else {
        this.prefabMusicArr.push({
          src: item.src,
          index: item.index
        });
        // this.mySound.play("Audio" + item.index);
        // this.$refs["Audio" + item.index][0].play();
        // this.$refs["Audio" + item.index][0].muted = "";
        this.prefabObj["audio" + item.index].volume(1);
        this.$set(this.prefabArr[i], "isplay", true);
        this.customizeArr[item.customizeIndex].clickCount++;
      }

      // for (let i = 10; i < this.prefabArr.length + 10; i++) {
      //   if (this.prefabArr[i - 10].isplay) {
      //     this.$refs["Audio" + i][0].muted = "";
      //   } else {
      //     this.$refs["Audio" + i][0].muted = "muted";
      //   }
      //   this.$refs["Audio" + i][0].play();
      // }
    },
    // 点击弹奏自定义乐器
    playMusic(item) {
      this.canCompleteMusic = true;
      this.BGM_.play();
      this.$refs.musicVideo.play();
      this.hintTxt = item.hintTxt;
      this.isShowHint = true;

      if (this.isReset) {
        for (let k = 0; k < this.prefabArr.length; k++) {
          this.prefabObj["audio" + this.prefabArr[k].index].volume(0);
          this.prefabObj["audio" + this.prefabArr[k].index].play();
        }
      }
      this.isReset = false;

      this.customMusicArr.push({
        src: item.src,
        time: this.BGM_.currentTime,
        index: item.index
      });
      let instance = this.mySound.play("Audio" + item.index);
      // let sound = this.customizeObj["audio" + item.index];
      // sound.play();
      this.$set(this.customizeArr[item.index], "isplay", true);
      this.$set(this.customizeArr[item.index], "disable", true);
      this.customizeArr[item.index].clickCount++;
      instance.on(
        "complete",
        () => {
          this.$set(this.customizeArr[item.index], "isplay", false);
          this.$set(this.customizeArr[item.index], "disable", false);
        },
        this
      );
      // sound.on("end", () => {
      //   this.$set(this.customizeArr[item.index], "isplay", false);
      //   this.$set(this.customizeArr[item.index], "disable", false);
      // })
    },
    // 重置音乐
    resetMusic() {
      (this.isReset = true), this.BGM_.pause();
      this.$refs.musicVideo.pause();
      this.BGM_.currentTime = 0;
      this.$refs.musicVideo.currentTime = 0;
      this.mySound.stop();
      this.canCompleteMusic = false;
      this.customMusicArr = [];
      this.prefabMusicArr = [];
      this.resultMusicArr = [
        {
          clickCount: 0,
          countImg: require("./assets/img/count_pp.png"),
          resultIndet: require("./assets/img/identity_pp.png"),
          phonograph: require("./assets/img/phonograph_pp.png"),
          posterTxt: require("./assets/img/poster_id_pp.png")
        }
      ];
      for (let i = 0; i < this.customizeArr.length; i++) {
        this.$set(this.customizeArr[i], "isplay", false);
        this.$set(this.customizeArr[i], "disable", false);
        this.$set(this.customizeArr[i], "clickCount", 0);
      }
      for (let j = 0; j < this.prefabArr.length; j++) {
        this.prefabObj["audio" + this.prefabArr[j].index].stop();
        this.$set(this.prefabArr[j], "isplay", false);
        this.$set(this.prefabArr[j], "clickCount", 0);
      }
    },
    // 完成音乐制作
    completeCreate() {
      this.BGM_.currentTime = 0;
      this.BGM_.pause();
      this.$refs.musicVideo.currentTime = 0;
      this.$refs.musicVideo.pause();

      for (let j = 0; j < this.prefabArr.length; j++) {
        this.prefabObj["audio" + this.prefabArr[j].index].stop();
        this.$set(this.prefabArr[j], "isplay", false);
      }

      // 生成结果 根据点击次数 取前四位
      if (!this.isShare) {
        this.resultMusicArr = JSON.parse(JSON.stringify(this.customizeArr));
        this.resultMusicArr = this.resultMusicArr.sort(function(a, b) {
          return b.clickCount - a.clickCount;
        });
        this.resultMusicArr = this.resultMusicArr.slice(0, 4);
      }

      let params = {
        prefabMusicArr: this.prefabMusicArr,
        customMusicArr: this.customMusicArr,
        resultMusicArr: this.resultMusicArr
      };
      // console.log(JSON.stringify(params));
      this.$loading.show();
      axios({
        url: "https://ichudong.cztv.com/data/composer/save",
        method: "POST",
        data: params,
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(res => {
        this.$loading.hide();
        this.isShowCreateMusicBox = false;
        this.isShowCompletePage = true;
        if (res.data.code === 200) {
          this.uuid = res.data.msg;

          let shareLink = `${window.location.href.split("?")[0]}?uuid=${
            res.data.msg
          }`;
          let ua_str = window.navigator.userAgent.toLowerCase();
          if (/chinabluetv/.test(ua_str)) {
            const shareData = {
              showShareBtn: true,
              url: shareLink, //分享的网址链接
              title: this.resultMusicArr[0].timelineTxt, //分享的标题
              content: "快来与我一起为“谷小雨”共谱新曲吧～", // 分享的文字
              img: "https://ohudong.cztv.com/1/264397/images/share.jpg" // 分享的图片Url
            };
            this.shareApp = new ShareApp("true", shareData);
            this.shareApp.changeShareInfo(shareData);
          } else {
            wxShare(
              true,
              this.resultMusicArr[0].timelineTxt,
              "快来与我一起为“谷小雨”共谱新曲吧～",
              this.resultMusicArr[0].timelineTxt,
              shareLink,
              "https://ohudong.cztv.com/1/264397/images/share.jpg"
            );
          }
        }
      });
    },
    // 播放最终合成的音乐
    playCreatedMusic() {
      this.BGM_.currentTime = 0;
      this.BGM_.play();
      this.isPlayMusic = true;
      for (let i = 0; i < this.customMusicArr.length; i++) {
        this.customMusicArr[i].isplay = false;
      }
      // 播放预制音乐
      for (let j = 0; j < this.prefabMusicArr.length; j++) {
        this.myPrefabSound.play("Audio" + this.prefabMusicArr[j].index);
      }
      this.BGM_.addEventListener(
        "timeupdate",
        () => {
          const currentTime = this.BGM_.currentTime;
          for (let i = 0; i < this.customMusicArr.length; i++) {
            if (
              currentTime > this.customMusicArr[i].time &&
              !this.customMusicArr[i].isplay &&
              this.isPlayMusic
            ) {
              this.mySound.play("Audio" + this.customMusicArr[i].index);
              this.customMusicArr[i].isplay = true;
            }
          }
        },
        false
      );
      this.BGM_.addEventListener(
        "ended",
        () => {
          this.isPlayMusic = false;
        },
        false
      );
    },
    // 重新演奏
    hideCompletePage() {
      this.resetMusic();
      this.isPlayMusic = false;
      this.canCompleteMusic = false;
      this.isShowCreateMusicBox = true;
      this.isShowCompletePage = false;
    },
    // 生成海报
    makePoster() {
      this.$loading.show();
      let localUrl = `${window.location.href.split("?")[0]}?uuid=${this.uuid}`;
      console.log(localUrl);
      QRCode.toDataURL(localUrl, { errorCorrectionLevel: "L" }).then(url => {
        Promise.all([
          this.loadImage(baseImg),
          this.loadImage(phonograph),
          this.loadImage(pointer),
          this.loadImage(titleMy),
          this.loadImage(descMy),
          this.loadImage(qrcodeTips),
          this.loadImage(this.resultMusicArr[0].posterId),
          this.loadImage(this.resultMusicArr[0].shareTxt),
          this.loadImage(this.resultMusicArr[0].posterCount),
          this.loadImage(this.resultMusicArr[1].posterCount),
          this.loadImage(this.resultMusicArr[2].posterCount),
          this.loadImage(this.resultMusicArr[3].posterCount),
          this.loadImage(url)
        ]).then(res => {
          let dpr = 2;
          var imgWidth = 750,
            imgHeight = 1500;
          var canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");
          canvas.width = imgWidth * dpr;
          canvas.height = imgHeight * dpr;
          ctx.scale(dpr, dpr);
          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, imgWidth, imgHeight);
          ctx.drawImage(res[0], 0, 0, imgWidth, imgHeight);
          ctx.drawImage(res[1], 165, 173, 420, 420);
          ctx.drawImage(res[2], 507, 164, 102, 326);
          ctx.drawImage(res[3], 0, 82, 750, 52);
          ctx.drawImage(res[4], 103, 812, 544, 26);
          ctx.drawImage(res[5], 522, 1280, 50, 100);
          ctx.drawImage(res[6], 105, 621, 540, 164);
          ctx.drawImage(res[7], 497, 959, 147, 272);
          ctx.drawImage(res[8], 93, 966, 305, 40);
          ctx.drawImage(res[9], 93, 1030, 305, 40);
          ctx.drawImage(res[10], 93, 1094, 305, 40);
          ctx.drawImage(res[11], 93, 1161, 305, 40);
          ctx.drawImage(res[12], 579, 1280, 100, 100);

          let family =
            '"Hiragino Sans GB", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif';
          // 设置文本样式
          ctx.fillStyle = "#A00A0A";
          ctx.textAlign = "center";
          ctx.font = "bold " + 38 + "px " + family;
          let txt0 =
            this.resultMusicArr[0].clickCount < 10
              ? "0" + this.resultMusicArr[0].clickCount
              : this.resultMusicArr[0].clickCount;
          let txt1 =
            this.resultMusicArr[1].clickCount < 10
              ? "0" + this.resultMusicArr[1].clickCount
              : this.resultMusicArr[1].clickCount;
          let txt2 =
            this.resultMusicArr[2].clickCount < 10
              ? "0" + this.resultMusicArr[2].clickCount
              : this.resultMusicArr[2].clickCount;
          let txt3 =
            this.resultMusicArr[3].clickCount < 10
              ? "0" + this.resultMusicArr[3].clickCount
              : this.resultMusicArr[3].clickCount;
          ctx.fillText(txt0, 335, 1000);
          ctx.fillText(txt1, 335, 1065);
          ctx.fillText(txt2, 335, 1130);
          ctx.fillText(txt3, 335, 1195);

          this.resultPoster = canvas.toDataURL();
          this.$loading.hide();

          let ua_str = window.navigator.userAgent.toLowerCase();
          let isAndroid =
            navigator.userAgent.indexOf("Android") > -1 ||
            navigator.userAgent.indexOf("Adr") > -1;

          if (/chinabluetv/.test(ua_str)) {
            if (isAndroid) {
              this.hidePoster = false;
              this.$toast("安卓端请截图保存分享哦～");
            }
          }
          this.isShowSavePage = true;
        });
      });
    },
    // 加载图片
    loadImage(image) {
      return new Promise((resolve, reject) => {
        // 创建 image 对象加载图片；
        let img = new Image();
        // 当为线上图片时，需要设置 crossOrigin 属性；
        if (image.indexOf("http") == 0) img.crossOrigin = "*";
        img.onload = () => {
          resolve(img);
          // 使用完后清空该对象，释放内存；
          setTimeout(() => {
            img = null;
          }, 1000);
        };
        img.onerror = () => {
          reject(`图片加载失败:${image}`);
        };
        img.src = image;
      });
    },
    // 我要演奏
    restart() {
      window.location.replace(window.location.href.split("?")[0]);
    }
  }
};
</script>

<style lang="less">
@font-face {
  font-family: "qkss";
  src: url("./assets/css/fontMin.ttf");
}
html,
body,
#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loading-page {
  width: 100%;
  height: 100%;
  background: url("./assets/img/loading_bg.jpg") no-repeat center;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  .loading-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -80%);
    font-size: 0;
    .icon-loading {
      width: 213px;
      height: 213px;
      animation: roll 1s linear infinite;
    }
    .progress-txt {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 80px;
      font-family: "qkss";
      text-align: center;
      color: #fff;
      span {
        font-size: 60px;
      }
    }
  }
  .rotate-tips {
    width: 446px;
    height: 37px;
    position: absolute;
    bottom: 225 / 750 * 100%;
    left: 50%;
    transform: translateX(-50%);
  }
  .swiper-container {
    width: 100%;
    height: 80px;
    bottom: 107 / 750 * 100%;
    position: absolute;
    left: 0;
    text-align: center;
  }
  .swiper-slide {
    text-align: center;
  }
  .loading-desc {
    display: block;
    margin: 0 auto;
    width: fit-content;
    padding: 13px;
    font-size: 22px;
    line-height: 25px;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    position: absolute;
    bottom: 127 / 750 * 100%;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
  }
  .logo {
    width: 146px;
    height: 40px;
    bottom: 60 / 750 * 100%;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
}
.start-cloud-btn {
  width: 236px;
  height: 104px;
  position: absolute;
  bottom: 59 / 750 * 100%;
  right: 68 / 1206 * 100%;
  z-index: 100;
  pointer-events: auto;
  // background: url("./assets/img/start_btn.png") no-repeat center;
  // background-size: 100% 100%;
  transform: translate3d(0, 0, 0);
  img {
    width: 100%;
    height: 100%;
    transform: translate(0, 0, 0);
  }
}
.cover-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform: translate3d(0, 0, 0);
}
.start-story-wrap {
  width: 413px;
  height: 745px;
  top: 0;
  left: 105 / 1206 * 100%;
  position: absolute;
  pointer-events: none;
  filter: drop-shadow(5px 5px 6px rgba(0, 0, 0, 0.3));
  overflow: hidden;
  .start-story {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  .light {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-mask: url("./assets/img/start_story.png");
    mask: url("./assets/img/start_story.png");
    -webkit-mask-size: 100%;
    mask-size: 100%;
    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      left: -100%;
      top: 0;
      background: rgb(255, 255, 255);
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 25%,
        rgba(255, 255, 255, 0) 50%,
        rgba(255, 255, 255, 1) 75%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
  &.ani {
    animation: fadeInUp 0.5s ease-out forwards;
    .light:before {
      animation: LightMove 2.5s 0.8s ease-in-out forwards;
    }
  }
}
.cloud-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 30;
  .cloud-img {
    pointer-events: none;
    width: 1334px;
    height: 730px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -375px;
    margin-left: -667px;
    animation: cloudAni 1s linear both;
  }
}
.earth-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("./assets/img/index_bg.jpg") no-repeat center;
  background-size: 100% 100%;
  background-color: #000;
  overflow: hidden;
  &.hide {
    opacity: 0;
  }
  img {
    pointer-events: none;
  }
  .theme {
    position: absolute;
    width: 767 / 1334 * 100%;
    top: 62 / 750 * 100%;
    left: 50%;
    transform: translateX(-49%);
    .theme-left {
      width: 166 / 767 * 100%;
      height: 100%;
      background: url("./assets/img/theme.png") no-repeat left;
      background-size: auto 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    .theme-center {
      width: 300 / 767 * 100%;
      height: 100%;
      background: url("./assets/img/theme.png") no-repeat;
      background-position: 39% 0;
      background-size: auto 100%;
      position: absolute;
      top: 0;
      left: 166 / 767 * 100%;
      opacity: 0;
    }
    .theme-right {
      width: 303 / 767 * 100%;
      height: 100%;
      background: url("./assets/img/theme.png") no-repeat right;
      background-size: auto 100%;
      position: absolute;
      top: 0;
      right: 0;
      opacity: 0;
    }
    .theme-img {
      width: 100%;
      opacity: 0;
    }
    &.animate {
      .theme-left {
        animation: fadeInLeft 1s 0.2s ease-out forwards;
      }
      .theme-center {
        animation: plusIn 1s 1s ease-out forwards;
      }
      .theme-right {
        animation: fadeInRight 1s 0.2s ease-out forwards;
      }
    }
  }
  .roll-box {
    pointer-events: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 28%;
    width: 393 / 1334 * 100%;
    z-index: 10;
    .roll-arrow {
      width: 100%;
    }
    .hand {
      position: absolute;
      width: 60 / 393 * 100%;
      left: 40%;
      bottom: -8%;
      animation: handAni 2s ease-out infinite;
    }
  }
  .roll-tips {
    position: absolute;
    width: 284 / 1334 * 100%;
    left: 50%;
    transform: translateX(-50%);
    bottom: 15%;
    z-index: 10;
  }
  .globe-box {
    left: 50%;
    top: 50%;
    z-index: 30;
  }
  .globe {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -1;
    top: 80px;
    left: 0;
    transition: all 1.2s ease-out;
    // opacity: 0;
    // display: none;
    &.animation {
      top: -50px;
      left: -60px;
      transform: scale(1.5) translateX(12%);
    }
  }
}
.video-page {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  .know-btn {
    width: 160px;
    height: 153px;
    position: absolute;
    transform: translate3d(0, 0, 0);
    z-index: 60;
    &.gq {
      top: 15%;
      right: 430px;
    }
    &.fx {
      top: 55%;
      right: 20%;
    }
    &.pp {
      top: 55%;
      left: 12%;
    }
    &.sz {
      bottom: 15%;
      left: 25%;
    }
    // animation: fadeIn 1.5s linear infinite;
  }
  .intro-tips {
    width: 846px;
    height: 121px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -60px;
    margin-left: -423px;
    transform: translate3d(0, 0, 0);
    z-index: 50;
    transition: all 0.2s linear;
    opacity: 0;
    &.show {
      opacity: 1;
    }
  }
  .video-pass-btn {
    width: 120px;
    height: 70px;
    position: absolute;
    top: 50px;
    right: 5%;
    z-index: 5;
    user-select: none;
    transform: translate3d(0, 0, 0);
  }
  .video-wrap,
  .video-scenes {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .video {
    // pointer-events: none;
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #000;
  }
  .touch-tips-box {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 65%;
    right: 25%;
    z-index: 5;
    user-select: none;
    pointer-events: none;
    &::after {
      content: "";
      width: 90px;
      height: 90px;
      top: 0;
      left: 0;
      position: absolute;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.2);
      animation: wavePlusAni 0.8s 0.3s ease-out infinite;
    }
    &::before {
      content: "";
      width: 56px;
      height: 56px;
      top: 17px;
      left: 17px;
      position: absolute;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.4);
      animation: waveAni 0.8s 0.2s ease-out infinite;
    }
    .hand {
      position: absolute;
      top: 34px;
      left: 34px;
      width: 59px;
      height: 60px;
      user-select: none;
      pointer-events: none;
      animation: guideHandAni 1s ease-out infinite;
    }
  }
  .click-tips-box {
    width: 109px;
    height: 94px;
    position: absolute;
    top: 62%;
    left: 45%;
    transform: translate(-50%, -50%);
    z-index: 5;
    pointer-events: none;
    .tips-icon-fx {
      width: 100%;
      height: 100%;
      display: none;
    }
    .fx-hand {
      width: 60px;
      height: 60px;
      position: absolute;
      top: 10px;
      left: 10px;
      animation: guideHandAni 1.2s ease-out infinite;
    }
    .tips-txt {
      width: fit-content;
      white-space: nowrap;
      font-size: 25px;
      letter-spacing: 1px;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      color: #fff;
      user-select: none;
      pointer-events: none;
    }
  }
  .move-tips-box {
    width: 260px;
    height: 45px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    pointer-events: none;
    .arrow-left {
      position: absolute;
      width: 60px;
      height: 28px;
      top: 2px;
      left: 0;
      animation: fadeInRight 1s ease-out infinite;
    }
    .arrow-right {
      position: absolute;
      width: 60px;
      height: 28px;
      top: 2px;
      right: 0;
      animation: fadeInLeft 1s ease-out infinite;
    }
    .move-hand {
      width: 49px;
      height: 45px;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -25px;
      animation: moveHandAni 1.2s linear infinite;
    }
    .tips-txt {
      width: fit-content;
      white-space: nowrap;
      font-size: 27px;
      letter-spacing: 1px;
      bottom: -50px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      color: #fff;
      user-select: none;
      pointer-events: none;
    }
  }
  .sz-click-box {
    width: 98px;
    height: 103px;
    position: absolute;
    z-index: 5;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
    .sz-click-hand {
      width: 100%;
      height: 100%;
      animation: guideHandAni 1.2s ease-out infinite;
    }
    .tips-txt {
      width: fit-content;
      white-space: nowrap;
      font-size: 25px;
      letter-spacing: 1px;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      color: #fff;
      user-select: none;
      pointer-events: none;
    }
  }
  .video-cover {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    width: 50%;
    height: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
  .tips-txt {
    width: fit-content;
    white-space: nowrap;
    font-size: 30px;
    letter-spacing: 2px;
    bottom: -50px;
    left: 10px;
    position: absolute;
    color: #fff;
    user-select: none;
    pointer-events: none;
  }
}
.scenes-end-page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url("./assets/img/scenes_end_bg.jpg") no-repeat center;
  background-size: cover;
  .cover-page {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    .start-btn {
      position: absolute;
      width: 680 / 1334 * 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.create-music-page {
  position: relative;
  z-index: 20;
  width: 100%;
  height: 100%;
  background-color: #272727;
  .client-box {
    width: 1279 / 1334 * 100%;
    height: 398 / 750 * 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    position: relative;
    .client-left {
      width: 225 / 1279 * 100%;
      height: 97%;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: start;
      margin-right: 30px;
      position: relative;
      .back-btn {
        width: 166px;
        height: auto;
        margin-left: -20px;
        &:active {
          transform: scale(0.9);
        }
      }
      .light-box {
        width: 86px;
        height: 41px;
        position: absolute;
        top: 15px;
        right: -15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .light-open {
          width: 41px;
          height: 41px;
          animation: fadeInOut 2.2s ease-out infinite;
        }
        .light-close {
          width: 31px;
          height: 31px;
        }
      }
      .wheel-box {
        width: 201px;
        height: 201px;
        border-radius: 50%;
        background-color: #222222;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        z-index: 5;
        .wheel {
          width: 100%;
          height: 100%;
        }
      }
      .seal {
        width: 100%;
        height: auto;
        opacity: 0;
      }
      .slogen {
        width: 339px;
        position: fixed;
        left: 0;
        top: 112px;
        z-index: 0;
      }
      .hint-box {
        width: 308px;
        min-height: 104px;
        position: fixed;
        left: 15px;
        top: 340px;
        background: url("./assets/img/hint_bg.png") no-repeat center;
        background-size: 100% 100%;
        padding-top: 42px;
        padding-left: 24px;
        padding-right: 15px;
        font-size: 18px;
        line-height: 24px;
        color: #b1c1d1;
        box-sizing: border-box;
        .close-btn {
          position: absolute;
          width: 46px;
          height: 46px;
          top: -10px;
          right: -10px;
          z-index: 20;
        }
        .icon-ding {
          position: absolute;
          width: 101px;
          height: 26px;
          top: 15px;
          left: 18px;
        }
      }
    }
    .video-box {
      width: 675 / 1279 * 100%;
      height: 380 / 398 * 100%;
      background: #000 url("./assets/img/video_bg.png") no-repeat center;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 7px 9px;
      border-radius: 5px;
      position: relative;
      z-index: 1;
      .video {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 6px;
      }
    }
    .client-right {
      width: 262 / 1279 * 100%;
      height: 96%;
      display: flex;
      flex-direction: row-reverse;
      position: relative;
      .dot1 {
        position: absolute;
        width: 39px;
        height: 39px;
        top: 6px;
        left: 18px;
      }
      .dot2 {
        position: absolute;
        width: 39px;
        height: 39px;
        top: 100px;
        left: 18px;
      }
      .music-control-container {
        width: 200 / 262 * 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
      }
      .music-control-box {
        width: 90%;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        display: none;
        .control-txt {
          font-size: 18px;
          color: #cac4c4;
        }
        .control-wrap {
          width: 90px;
          height: 100%;
          position: relative;
          background: url("./assets/img/music_control_bg.png") no-repeat center;
          background-size: 100% 100%;
          .music-control-icon {
            width: 32px;
            height: 32px;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .music-track {
        display: block;
        width: 152 / 200 * 100%;
        height: 100%;
      }
      .music-gif {
        position: absolute;
        width: 128 / 200 * 100%;
        left: 50%;
        transform: translateX(-50%);
        bottom: 10%;
      }
      .vol-control-box {
        position: absolute;
        left: 25px;
        bottom: 5px;
        width: 30px;
        height: 190px;
        background: url("./assets/img/vol_control_bg.png") no-repeat center;
        background-size: 100% 100%;
        .dot-min {
          position: absolute;
          width: 28px;
          height: 28px;
          left: -10px;
          top: 30%;
        }
      }
    }
    .line {
      width: 100%;
      height: 6px;
      position: absolute;
      display: block;
      // margin: 20px auto;
      left: 50%;
      transform: translateX(-50%);
      bottom: -25px;
    }
  }
  .musical-instrument-box {
    width: 1279 / 1334 * 100%;
    height: 280 / 750 * 100%;
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    .line {
      width: auto;
      height: 276 / 280 * 100%;
      margin-left: 20px;
      margin-right: 20px;
    }
    .control-left-box {
      width: 470 / 1279 * 100%;
      height: 100%;
      .title {
        width: 461 / 470 * 100%;
        height: auto;
      }
      .musical-instrument-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 15px;
        .musical-instrument-item {
          width: 23%;
          // height: 101px;
          // background: url("./assets/img/icon_gq.png") no-repeat top;
          // background-size: 100% 100%;
          display: flex;
          flex-wrap: nowrap;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          &.disable {
            pointer-events: none;
          }
          .item-img {
            width: 90px;
            height: 101px;
            img {
              width: 100%;
              height: auto;
            }
            // background: url("./assets/img/icon_gq.png") no-repeat top;
            // background-size: 100% 100%;
            // &.active {
            //   background: url("./assets/img/icon_gq_act.png") no-repeat top;
            //   background-size: 100% auto;
            // }
            &.disable {
              pointer-events: none;
            }
          }
          .name {
            font-size: 20px;
            width: 20px;
            color: #636366;
          }
        }
      }
    }
    .control-center-box {
      width: 527 / 1279 * 100%;
      height: 100%;
      text-align: left;
      .title {
        width: 489 / 527 * 100%;
        height: auto;
      }
      .musical-instrument-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 10px 0px 0px 15px;
        // margin: 0 auto;
        margin-top: 10px;
        box-sizing: border-box;
        background: url("./assets/img/musical_instrument_wrap_bg.png") no-repeat
          center;
        background-size: 100% 100%;
        .musical-instrument-icon {
          width: 20%;
          position: relative;
          &.disable {
            pointer-events: none;
          }
          .icon-img {
            width: 83%;
          }
          .icon-img-act {
            position: absolute;
            width: 89%;
            top: -5px;
            left: -3px;
          }
        }
      }
    }
    .control-right-box {
      width: 166 / 1278 * 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: -10px;
      position: relative;
      .reset-btn {
        width: 151 / 166 * 100%;
        height: auto;
        margin-bottom: 10px;
        &:active {
          transform: scale(0.95);
        }
      }
      .confirm-btn {
        width: 100%;
        height: auto;
        &:active {
          opacity: 0.9;
          transform: scale(0.98);
        }
      }
      .confirm-btn-dis {
        width: 100%;
        height: auto;
      }
    }
  }
  .guide-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 10;
    .guide-btn,
    .guide-end-btn {
      width: 630 /1334 * 100%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .guide-tips-wrap {
      width: 832 /1334 * 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .guide-tips-btn {
        width: 100%;
        height: auto;
      }
      .guide-tips-hand {
        position: absolute;
        top: 310px;
        left: 260px;
        width: 81px;
        height: 75px;
        animation: guideHandAni 1.2s ease-out infinite;
        pointer-events: none;
      }
    }

    .guide-hand {
      width: 88px;
      height: 85px;
      position: absolute;
      bottom: -33px;
      right: -34px;
      pointer-events: none;
      animation: guideHandAni 1.5s ease-out infinite;
    }
    .guide-box1 {
      position: absolute;
      bottom: 120px;
      left: 250px;
      font-size: 0;
      .music-btn1 {
        width: 120px;
        height: 127px;
      }
      .music-btn2 {
        width: 120px;
        height: 124px;
      }
      .guide-text1 {
        position: absolute;
        width: 380px;
        height: 50px;
        right: -34 - 380px;
        bottom: 33px;
      }
      .guide-text2 {
        position: absolute;
        width: 380px;
        height: 84px;
        right: -43 -380px;
        top: 23px;
      }
    }
    .guide-box2 {
      position: absolute;
      bottom: 122px;
      left: 50%;
      margin-left: -100px;
      font-size: 0;
      .guide-music-btn3 {
        width: 120px;
        height: 126px;
      }
      .guide-text3 {
        position: absolute;
        width: 380px;
        height: 50px;
        right: -18 - 380px;
        top: 36px;
      }
      .guide-music-btn4 {
        width: 120px;
        height: 126px;
        // position: absolute;
        // top: -1px;
        // left: 0;
      }
      .guide-text4 {
        position: absolute;
        width: 396px;
        height: 83px;
        right: -18 - 398px;
        top: 20px;
      }
    }
  }
}
.complete-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("./assets/img/result_bg.jpg") no-repeat center;
  background-size: 100% 100%;
  .inner-page {
    position: absolute;
    width: (400 + 124 + 503) / 1206 * 100%;
    display: flex;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
  .left-box {
    width: 450px;
    height: 450px;
    .phonograph-box {
      width: 100%;
      height: 100%;
      position: relative;
      .phonograph {
        width: 100%;
        height: 100%;
      }
      .play-icon {
        width: 104px;
        height: 104px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .pointer-box {
        position: absolute;
        top: -57px;
        right: -86px;
        width: 231px;
        height: 434px;
        transform-origin: 184px 47px;
        transform: rotate(-15deg);
        transition: all 0.5s linear;
        .pointer {
          width: 100%;
          height: 100%;
        }
      }
      &.play {
        .phonograph {
          animation: roll 12s linear infinite;
        }
        .pointer-box {
          transform: rotate(0deg);
        }
        .pointer {
          animation: pointerAni 1.2s ease-out infinite;
        }
      }
    }
    .ai-tips {
      width: 504px;
      height: 74px;
      margin-top: 12px;
    }
  }
  .right-box {
    width: 533px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    .result-tips {
      width: 318px;
      height: 32px;
    }
    .identity {
      width: 503px;
      height: 150px;
      margin-top: 22px;
      margin-bottom: 51px;
    }
    .header {
      width: 503px;
      height: 60px;
      margin-bottom: 12px;
    }
    .result-box {
      display: flex;
      justify-content: start;
      flex-wrap: nowrap;
      margin-bottom: 35px;
      .result-count-box {
        display: flex;
        flex-wrap: wrap;
        margin-right: 65px;
        .result-count {
          width: 216px;
          height: 40px;
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .count {
          position: absolute;
          font-size: 26px;
          color: #e2bd82;
          line-height: 26px;
          top: 50%;
          transform: translateY(-30%);
          font-weight: 500;
          right: 36px;
        }
      }
      .result-txt {
        width: 274px;
        height: 172px;
      }
    }
    .btn-box {
      display: flex;
      width: 503px;
      height: 90px;
      justify-content: space-between;
      .replay-btn,
      .share-btn {
        width: 217px;
        height: 90px;
      }
    }
    .restart-btn {
      width: 438px;
      height: 90px;
      margin: 0 auto;
    }
  }
}
.poster-page {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.9);
  top: 0;
  left: 0;
  z-index: 30;
  .close-btn {
    width: 66px;
    height: 66px;
    position: absolute;
    top: 35px;
    right: 93px;
    z-index: 50;
  }
  .inner-page {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: nowrap;
    .poster {
      width: 338px;
      height: 675px;
    }
    .poster-txt {
      width: 147px;
      height: 272px;
    }
    .desc-box {
      margin-left: 33px;
      width: 234px;
      height: 675px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      .desc-title {
        width: 160px;
        height: 68px;
        margin-top: 62px;
      }
      .save-tips {
        width: 234px;
        height: 62px;
      }
    }
    .cover-poster-wrap {
      position: absolute;
      top: 0;
      right: 0;
      // pointer-events: none;
    }
    .cover-poster {
      transform: rotate(-90deg) translateX(50%);
      width: 675px;
      // height: 675px;
      // position: absolute;
      // top: 0;
      // right: 0;
      &.hide {
        opacity: 0;
      }
    }
  }
}
@media screen and (max-height: 680px) {
  .create-music-page {
    .client-box {
      width: 1280 / 1334 * 100%;
      .client-left {
        .back-btn {
          width: 146px;
        }
        .hint-box {
          z-index: 50;
        }
      }
    }
  }
  .complete-page {
    .inner-page {
      width: (400 + 124 + 563) / 1206 * 100%;
    }
  }
}
@keyframes fadeIn {
  from {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes LightMove {
  from {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(200%, 0, 0);
  }
}
@keyframes globeAni {
}
@keyframes cloudAni {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  30% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: scale(6);
  }
}
@keyframes roll {
  from {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes handAni {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(50px, -20px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes guideHandAni {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(10px, 10px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes fadeInOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}
@keyframes pointerAni {
  from {
    transform: rotate(1deg);
    transform-origin: 184px 47px;
  }
  25% {
    transform: rotate(0deg);
    transform-origin: 184px 47px;
  }
  55% {
    transform: rotate(-1deg);
    transform-origin: 184px 47px;
  }
  75% {
    transform: rotate(0deg);
    transform-origin: 184px 47px;
  }
  to {
    transform: rotate(1deg);
    transform-origin: 184px 47px;
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-50%);
  }
  to {
    opacity: 1;
    transform: translateX(0%);
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(50%);
  }
  to {
    opacity: 1;
    transform: translateX(0%);
  }
}
@keyframes plusIn {
  from {
    opacity: 0;
    transform: scale(3);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes wavePlusAni {
  from {
    transform: scale(0.5);
  }
  50% {
    opacity: 0;
    transform: scale(1.5);
  }
}
@keyframes waveAni {
  from {
    transform: scale(0.6);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.3);
  }
}
@keyframes moveHandAni {
  from {
    transform: translateX(0%);
  }
  25% {
    transform: translateX(-50%);
  }
  50% {
    transform: translateX(0%);
  }
  75% {
    transform: translateX(50%);
  }
}
</style>
